import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Component({
    selector: 'app-silent-refresh',
    templateUrl: './silent-refresh.component.html',
    standalone: false
})
export class SilentRefreshComponent implements OnInit {

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.authService.completeSilentRenew().catch(err => {
      console.warn('Silent renew callback failed', err);
    });
  }

}
